import {  getSEO } from '@/api/api';

export default {
  namespaced: true,
  state: {
   
    SEO:{}
  },
  mutations: {
    setSEO: (state, data) => {
      state.SEO = data;
    },
  },
  actions: {
    fetchSEO({ commit, state }, params) {
      return new Promise((resolve, reject) => {
        getSEO(params).then((response) => {
          let _data = JSON.parse(JSON.stringify(response.data));
          commit('setSEO', _data)
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/details.js